import { Component, ChangeDetectorRef } from '@angular/core';
import { TextEditorService } from '@fi-shared/fi-text-editor/text-editor.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppTextService } from '@fi-shared/app-text';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

@Component({
    selector: 'fi-text-editor-insert-embed-video-dialog',
    template: `
        <div class="content-header">{{ 'text_editor.video_embed_code' | fiAppText }}</div>
        <div class="BrandedBorderColorFocus-Input">
          <textarea [(ngModel)]="url" [required]="true" rows="4" (ngModelChange)="updateSafeUrl()"></textarea>
        </div>
        @if (!isUrlValid) {
          <span class="error">{{ 'text_editor.video_embded_code_invalid' | fiAppText }}</span>
        }
        @if (safeUrl) {
          <iframe [src]="safeUrl" frameborder="0" allowfullscreen></iframe>
        }
        `,
    styleUrls: ['./text-editor-insert-embed-video-dialog.component.scss'],
    standalone: false,
})
export class TextEditorInsertEmbedVideoDialogComponent extends FiDialogsContentBase<
    string,
    {
        url: string;
        textContent: string;
    }
> {
    url: string;
    isUrlValid: boolean = false;

    safeUrl: SafeResourceUrl;

    private textEditorService: TextEditorService;
    private sanitizer: DomSanitizer;
    private appTextService: AppTextService;
    private cdr: ChangeDetectorRef;

    ngOnInit() {
        this.textEditorService = this.injector.get(TextEditorService);
        this.sanitizer = this.injector.get(DomSanitizer);
        this.appTextService = this.injector.get(AppTextService);
        this.cdr = this.injector.get(ChangeDetectorRef);
        this.url = this.data;
        this.updateSafeUrl();
    }

    getResult() {
        let textContent = this.url || '';
        if (textContent.indexOf('iframe') !== -1) {
            textContent = this.textEditorService.getEmbdedVideoUrl(this.url);
        }
        return {
            url: this.url,
            textContent: this.appTextService.get('text_editor.video_from') + ' ' + textContent,
        };
    }

    updateSafeUrl() {
        this.isUrlValid = this.textEditorService.isEmbdedVideoUrlValid(this.url);

        if (this.isUrlValid) {
            const embdedUrl = this.textEditorService.getEmbdedVideoUrl(this.url);
            this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embdedUrl);
        } else {
            this.safeUrl = null;
        }
        this.cdr.markForCheck();
    }

    isYesButtonDisabled() {
        return !this.isUrlValid;
    }
}
